import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  loading: true,
  resulPushMessage: null,
  error: null,
}

// mutations
export const mutations = {
  [types.PUSH_MESSAGE_START] (state) {
    state.loading = true
    state.resulPushMessage = null
    state.error = null
  },

  [types.PUSH_MESSAGE_SUCCESS] (state, { data }) {
    state.loading = false
    state.resulPushMessage = data
    state.error = null
  },

  [types.PUSH_MESSAGE_ERROR] (state, { error }) {
    state.loading = false
    state.resulPushMessage = null
    state.error = error
  },
}

export const actions = {
  /**
   * @param {Number} payload
   */
  async pushMessage ({ commit }, { title, body }) {
    try {
      commit(types.PUSH_MESSAGE_START)
      const { data } = await axios.get(`/api/push_messages/send/${title}/${body}`)

      commit(types.PUSH_MESSAGE_SUCCESS, { data })
    } catch (e) {
      commit(types.PUSH_MESSAGE_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingResulPushMessage: state => state.loading,
  resulPushMessage: state => state.resulPushMessage,
  errorResulPushMessage: state => state.error,
}
